export const initialState = {
	years: [{ value: -1, display: 'Year' }],
	makes: [{ value: 'make', display: 'Make' }],
	models: [{ value: 'model', display: 'Model' }],
	selected: {
		year: -1,
		make: 'make',
		model: 'model'
	},
	vehicleFeet: -1,
	vehicleInches: -1,
	storageMinLength: -1,
	vehicleCouldNotBeFound: false,
	isLoading: true,
	hasError: false
};

export const ApiMinYear = 1941;
